import { atomWithStorage } from 'jotai/utils';

/**
 * Representa uma categoria da biblioteca de slides.
 */
export interface SlideCategory {
  readonly id: number;
  readonly name: string;
}

/**
 * Átomo persistido em localStorage com todas as categorias da biblioteca de slides.
 * Fonte de verdade local até integração com backend.
 */
export const slideCategoriesAtom = atomWithStorage<SlideCategory[]>('slide-categories', []);
slideCategoriesAtom.debugLabel = 'slide-libary/slideCategoriesAtom';
